<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<app-academic-headers></app-academic-headers>
<div class="epf">
  <div class="epf__card">
    <header class="epf__head">
      <div class="epf__head-text">
        <h1 class="epf__title">Employee Profile</h1>
      </div>
      <button *ngIf="selectedProfile" type="button" class="epf__clear-btn" (click)="clearProfile()">
        Clear
      </button>
    </header>

    <section class="epf__sec" aria-labelledby="epf-search">
      <h2 id="epf-search" class="epf__sec-title">Employee Search</h2>
      <div class="epf__fld epf__fld--search">
        <input
          id="epf-search-input"
          type="text"
          class="epf__inp"
          matInput
          placeholder="Enter name, payroll or mobile"
          [formControl]="searchControl"
          [matAutocomplete]="empAuto"
        />
        <mat-autocomplete
          #empAuto="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="displayEmployeeLabel"
          (optionSelected)="onEmployeeSelected($event)"
        >
          <mat-option
            *ngFor="let item of employeeOptions | async; trackBy: trackByPayrollId"
            [value]="item"
          >
            <span class="epf__option">
              <span class="epf__option-id">{{ getOptionPayrollId(item) }}</span>
              <span class="epf__option-sep" *ngIf="getOptionPayrollId(item) && getOptionName(item)"> - </span>
              <span class="epf__option-name">{{ getOptionName(item) }}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
      </div>
    </section>

    <section *ngIf="showEmptyState" class="epf__sec epf__sec--empty" aria-live="polite">
      <div class="epf__empty">
        <figure class="epf__empty-figure">
          <img src="assets/image/nodata.png" alt="" class="epf__empty-img" />
        </figure>
        <p class="epf__empty-text">{{ emptyStateMessage }}</p>
      </div>
    </section>

    <section class="epf__sec" aria-labelledby="epf-profile" *ngIf="showProfileSections">
      <h2 id="epf-profile" class="epf__sec-title">Profile Details</h2>
      <div class="epf__profile">
        <aside class="epf__photo" aria-label="Employee photo">
          <img
            *ngIf="profileImageUrl"
            class="epf__photo-img"
            [src]="profileImageUrl"
            alt="Employee profile photo"
          />
          <div *ngIf="!profileImageUrl" class="epf__photo-placeholder" aria-hidden="true">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path
                d="M5 20C5 16.6863 8.13401 14 12 14C15.866 14 19 16.6863 19 20"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </aside>
        <div class="epf__grid" [formGroup]="profileForm">
          <div class="epf__fld" *ngFor="let field of profileFields">
            <label class="epf__lbl" [attr.for]="field.id">{{ field.label }}</label>
            <input [id]="field.id" type="text" class="epf__inp" [formControlName]="field.key" readonly />
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="epf__card" *ngIf="showProfileSections" [formGroup]="profileForm">
    <h2 class="epf__card-title">Campus Details</h2>
    <div class="epf__grid epf__grid--campus">
      <div class="epf__fld" *ngFor="let field of campusFields">
        <label class="epf__lbl" [attr.for]="field.id">{{ field.label }}</label>
        <input [id]="field.id" type="text" class="epf__inp" [formControlName]="field.key" readonly />
      </div>

      <div class="epf__fld">
        <label class="epf__lbl" for="epf-campus">Campus</label>
        <mat-select
          *ngIf="campusList.length > 1"
          id="epf-campus"
          class="epf__inp epf__inp--select"
          formControlName="campusName"
          placeholder="Select campus"
          panelClass="epf-campus-panel"
          disableOptionCentering
          (selectionChange)="onCampusChange($event.value)"
          (openedChange)="onCampusDropdownOpened($event)"
        >
          <input
            matInput
            class="epf__campus-search"
            placeholder="Search campus"
            [formControl]="campusSearch"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
          <mat-option *ngFor="let campus of filteredCampusList" [value]="campus.campusName">
            {{ campus.campusName }}
          </mat-option>
          <mat-option *ngIf="!filteredCampusList.length" disabled>No campus found</mat-option>
        </mat-select>
        <input
          *ngIf="campusList.length <= 1"
          id="epf-campus"
          type="text"
          class="epf__inp"
          formControlName="campusName"
          readonly
        />
      </div>

      <div class="epf__building-dropdown-host" #buildingDropdownHost>
      <div class="epf__fld epf__fld--building">
        <label class="epf__lbl" for="epf-buildings">Building</label>
        <div class="epf__building-wrap">
          <div *ngIf="buildingDropdownActive" class="epf__building-change-panel">
            <label class="epf__lbl" for="epf-building-search">Select Building</label>
            <input
              id="epf-building-search"
              type="text"
              class="epf__inp epf__building-search"
              placeholder="Search building"
              [formControl]="buildingSearch"
              autocomplete="off"
            />
            <div class="epf__building-options" role="listbox" aria-label="Building options">
              <button
                *ngFor="let building of filteredBuildingList"
                type="button"
                class="epf__building-option"
                [class.epf__building-option--selected]="building.label === pendingBuildingLabel"
                role="option"
                [attr.aria-selected]="building.label === pendingBuildingLabel"
                (click)="onPendingBuildingChange(building.label)"
              >
                <span class="epf__building-option-text">{{ building.label }}</span>
                <span
                  *ngIf="building.label === pendingBuildingLabel"
                  class="epf__building-option-tick"
                  aria-hidden="true"
                >✓</span>
              </button>
              <p *ngIf="!filteredBuildingList.length" class="epf__building-options-empty">
                No building found
              </p>
            </div>
            <div class="epf__building-change-actions">
              <button
                type="button"
                class="epf__change-building-btn epf__change-building-btn--save"
                [disabled]="isSaveBuildingDisabled"
                (click)="onSaveBuildingClick()"
              >
                Save
              </button>
              <button
                type="button"
                class="epf__change-building-btn epf__change-building-btn--cancel"
                [disabled]="savingBuilding"
                (click)="closeBuildingChangePanel()"
              >
                Cancel
              </button>
            </div>
          </div>

          <input
            id="epf-buildings"
            type="text"
            class="epf__inp"
            formControlName="buildingName"
            readonly
          />
        </div>
      </div>

      <div class="epf__fld epf__fld--building-action" *ngIf="currentCampusId">
        <span class="epf__lbl epf__lbl--spacer" aria-hidden="true">&nbsp;</span>
        <button
          type="button"
          class="epf__change-building-btn"
          [disabled]="isChangeBuildingDisabled"
          (click)="onChangeBuildingClick()"
        >
          Change Building
        </button>
      </div>
      </div>
    </div>
  </div>
</div>
<app-academic-footers></app-academic-footers>
